<template>
  <div :class="['tva-slider']">
    <div class="tva-slider-container" ref="slider">
      <slot></slot>
    </div>
    <div
      v-if="dots"
      class="tva-dots"
      :style="{ top: `calc(${dotsPosition}% - ${dotsSize / 2}px` }"
    >
      <div
        class="tva-dot"
        v-for="(dot, dotIndex) in elementsCount"
        :key="'dot-' + dotIndex"
        @click="goTo(dotIndex)"
        :style="{
          background: index === dotIndex ? dotActiveBgColor : dotBgColor,
          border: `solid ${dotStrokeWidth}px ${
            index === dotIndex ? dotActiveStrokeColor : dotStrokeColor
          }`,
          marginRight: dotGap + 'px',
          width: dotsSize + 'px',
          height: dotsSize + 'px'
        }"
      ></div>
    </div>
    <div
      v-if="arrows"
      class="tva-arrows"
      :style="{ top: `calc(${arrowsPosition}% - ${arrowsSize / 2}px)` }"
    >
      <div
        class="tva-arrow tva-arrow-sx"
        :style="{
          borderColor:
            index === 0 ? arrowDisabledBorderColor : arrowBorderColor,
          borderWidth: arrowBorderWidth + 'px',
          background: index === 0 ? arrowDisabledBgColor : arrowBgColor,
          width: arrowsSize + 'px',
          height: arrowsSize + 'px',
          pointerEvents: index === 0 ? 'none' : 'all'
        }"
        @click="goPrevious()"
      >
        <svg class="tva-arrow-icon" viewBox="0 0 100 100">
          <path
            d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
            :style="{ fill: index === 0 ? arrowDisabledColor : arrowColor }"
          />
        </svg>
      </div>
      <div
        class="tva-arrow tva-arrow-dx"
        :style="{
          borderColor:
            index === elementsCount.length - 1
              ? arrowDisabledBorderColor
              : arrowBorderColor,
          borderWidth: arrowBorderWidth + 'px',
          background:
            index === elementsCount.length - 1
              ? arrowDisabledBgColor
              : arrowBgColor,
          width: arrowsSize + 'px',
          height: arrowsSize + 'px',
          pointerEvents: index === elementsCount.length - 1 ? 'none' : 'all'
        }"
        @click="goNext()"
      >
        <svg class="tva-arrow-icon" viewBox="0 0 100 100">
          <path
            d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"
            transform="translate(100, 100) rotate(180)"
            :style="{
              fill:
                index === elementsCount.length - 1
                  ? arrowDisabledColor
                  : arrowColor
            }"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Flickity from "flickity-imagesloaded";
import _ from "lodash";
// import Flickity from "flickity-fade";
export default {
  props: {
    config: { type: Object, default: null }
  },
  data() {
    return {
      isFlickity: false,
      elementsCount: [],
      index: 0,
      arrows: true,
      arrowsPosition: 50,
      arrowsSize: 25,
      arrowBgColor: "transparent",
      arrowColor: "black",
      arrowDisabledBgColor: "transparent",
      arrowDisabledColor: "darkgrey",
      arrowDisabledBorderColor: "darkgrey",
      arrowBorderColor: "black",
      arrowBorderWidth: 2,
      dots: true,
      dotsPosition: 110,
      dotsSize: 10,
      dotActiveStrokeColor: "black",
      dotActiveBgColor: "black",
      dotStrokeColor: "black",
      dotStrokeWidth: 2,
      dotBgColor: "transparent",
      dotGap: 10,
      fade: false,
      options: {
        draggable: ">1",
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        lazyLoad: true,
        adaptiveHeight: true,
        fade: false
      }
    };
  },
  created() {
    this.setProps(this.config);
  },
  watch: {
    config(config) {
      this.setProps(config);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.elementsCount = new Array(this.$refs.slider.childElementCount).fill(
        0
      );
      this.createFlickity();

      window.addEventListener("resize", () => {
        this.createFlickity();
      });
    });
  },
  methods: {
    setProps(config) {
      if (config) {
        _.forEach(config, (value, key) => {
          this[key] = value;
        });
      }
    },
    createFlickity() {
      var elem = this.$refs.slider;

      if (elem && !this.isFlickity) {
        this.flkty = new Flickity(elem, this.options);

        this.flkty.on("change", index => {
          this.index = index;
          // this.$emit("change", index);
        });

        // this.$emit("setSlideAmount", this.flkty.slides.length);

        // this.flkty.on(
        //   "staticClick",
        //   (event, pointer, cellElement, cellIndex) => {
        //     this.$emit("click", cellElement, cellIndex);
        //   }
        // );

        this.isFlickity = true;
      } else if (!elem && this.isFlickity) {
        this.flkty.destroy();
        this.flkty = null;
        this.isFlickity = false;
      }
    },
    goTo(index) {
      this.flkty.select(index);
    },
    goPrevious() {
      this.flkty.previous();
    },
    goNext() {
      this.flkty.next();
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  height: 100%;
}

.tva-slider-container {
  width: 100%;
}
.tva-dots,
.tva-arrows {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.tva-slider {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .tva-dots {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    z-index: 1;
    cursor: pointer;
    .tva-dot {
      border-radius: 50%;
      &:last-of-type {
        margin-right: 0 !important;
      }
    }
  }
  .tva-arrows {
    z-index: 1;
    height: auto;
    display: flex;
    justify-content: space-between;
    pointer-events: none;
    .tva-arrow {
      cursor: pointer;
      pointer-events: all;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border-style: solid;
      &.tva-arrow-sx {
        margin-left: 20px;
      }
      &.tva-arrow-dx {
        margin-right: 20px;
      }
      .tva-arrow-icon {
        width: 70%;
      }
    }
  }
}
</style>

<style lang="scss">
/*! Flickity v2.2.0
https://flickity.metafizzy.co
---------------------------------------------- */

.flickity-enabled {
  position: relative;
}

.flickity-enabled:focus {
  outline: none;
}

.flickity-viewport {
  overflow: hidden;
  position: relative;
  height: 100%;
}

.flickity-slider {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* draggable */

.flickity-enabled.is-draggable {
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.flickity-enabled.is-draggable .flickity-viewport {
  cursor: move;
  cursor: -webkit-grab;
  cursor: grab;
}

.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
</style>
